import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import api_amr from 'services/api_amr';
import { getToken } from 'utils/utils';
import { Dialog, DialogContent } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { makeStyles } from "@material-ui/core/styles";
import GraficoFuturosComponent from './GraficoFuturosComponent';
import logoLoader from 'assets/img/loader_gif.gif';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';


const OverLayLogoAMRcarregando = () => {
    /* Componente a ser renderizado como overlay customizado caso a tabela esteja carregando */
    return (
        <div style={{ width: 'auto', height: '70%', position: 'relative' }}>
            <img src={logoLoader} alt="AMRLoader" style={{ width: 'auto', height: 'auto' }} />
        </div>
    );
};
const ArrowCellRenderer = ({ value }) => {
    let color;
    let arrow = "";

    if (parseFloat(value) > 0) {
        color = "green";
        arrow = "↑";
    } else if (parseFloat(value) < 0) {
        color = "red";
        arrow = "↓";
    } else {
        color = "black";
    }

    return (
        <div style={{ color: color }}>
            {value} {arrow}
        </div>
    );
};
export default function TabelaFuturosComponent({ parametros }) {
    /*
    * Componente Tabela Futuros utilizando a biblioteca AG-Grid
    * Para mais informações consulte a documentação em: https://www.ag-grid.com/react-data-grid/
    */

    const gridRef = useRef(null);
    const classes = useStyles()
    const [data, setData] = useState([])
    const [columnDefs] = useState([ 
                                    {"field":"contrato",  flex: 1,"headerName":"Contrato"},
                                    {"field":"ultima_valor", flex: 1, "headerName":"Último Valor",  valueFormatter: (params) => `${parseFloat(params.value).toLocaleString('pt-br', { style: 'currency', currency: 'USD' })}`},
                                    {"field":"variacao_hoje", flex: 1, "headerName":"Variação Hoje",cellStyle: params => getCellStyle(params.value), valueFormatter: (params) => { return `${CallArrowCell(params.value)}${params.value}%`}},
                                    {"field":"variacao_7dias", flex: 1, "headerName":"Variação 7 dias", cellStyle: params => getCellStyle(params.value), valueFormatter: (params) => {return `${CallArrowCell(params.value)}${params.value}%`}},
                                    {"field":"variacao_30dias", flex: 1, "headerName":"Variação 30 dias", cellStyle: params => getCellStyle(params.value), valueFormatter: (params) => {return `${CallArrowCell(params.value)}${params.value}%`}}
                                ])
    const [selected, setSelected] = useState('')
    const [selectedTabela, setSeleectedTabela] = useState('')
    const [openChart, setOpenChart] = useState(false)
    const [tabela, SetTabela] = useState('')
    const tabelaFuturoOptions = {
         'ureia_egy_futuro': 'Ureia Egyto' ,
         'ureia_me_futuro': 'Ureia Mediterrâneo' ,
         'dap_nola_futuro': 'DAP Nola' ,
         'map_br_futuro': 'MAP Brasil' ,
         'ureia_us_futuro': 'Ureia US' ,
         'ureia_br_futuro': 'Ureia BR' ,}
    

    const monthNames = {
        "JAN": 1,
        "FEB": 2,
        "MAR": 3,
        "APR": 4,
        "MAY": 5,
        "JUN": 6,
        "JUL": 7,
        "AUG": 8,
        "SEP": 9,
        "OCT": 10,
        "NOV": 11,
        "DEC": 12
    };

    useEffect(() => {
        handleGridReady()
    }, [parametros])

    const handleGridReady = async () => {
        /*
         * Esta função é executada quando o evento onGridReady ocorre.
         * O evento ocorre quando a tabela é renderizada, portanto serve como um useEffect do componente AG-Grid
         */

        // Chamada de dados e definição das colunas no back
        try {
           
            
            const response = await api_amr.get('/return_component_Futuros', { params: { 'formato': 'tabela', 'parametros': parametros }, headers: { 'x-api-key': getToken() } });
            let data = response.data.dados
           
            
            data.sort((a, b) => {
                const [monthA, yearA] = a.contrato.split(" ");
                const [monthB, yearB] = b.contrato.split(" ");
            
                const numYearA = parseInt(yearA, 10);
                const numYearB = parseInt(yearB, 10);
                const numMonthA = monthNames[monthA];
                const numMonthB = monthNames[monthB];
            
                if (numYearA !== numYearB) {
                    return numYearB - numYearA;
                }
                
                return numMonthB - numMonthA;
            });
            setData(data)
            setSeleectedTabela(parametros.tabela)
            SetTabela(tabelaFuturoOptions[parametros.tabela])
            /*
            * Antes de setar as configurações é necessário altera-la para adicionar um formatador de valores
            * O proprio ag-grid tem um propriedade para onde é passado uma função parar formatar os dados, essa é a maneira correta,
            * para maiores informações, acesse a documentação em: https://www.ag-grid.com/react-data-grid/value-formatters/#value-formatter-vs-cell-renderer
            * 
            * Aqui tambem podemos adicionar as configurações para cada coluna, como filtros que podem ser de texto, data ou numero. Para maiores
            * informações, acesse a documentação em: https://www.ag-grid.com/react-data-grid/filtering-overview/
            */



        } catch (error) {
            console.error("Erro ao buscar dados: ", error);
        }

    };

    const getCellStyle = (value) => {
        let color;
        let weight;
        if (parseFloat(value) > 0) {
            color = "green";
            weight = "bold"
        } else if (parseFloat(value) < 0) {
            color = "red";
            weight = "bold"
        } else {
            color = "black";
        }
        return { color, weight };
    };

    const CallArrowCell = (value) => {
        let arrowUp = " ↑ ";
        let arrowDown = " ↓ "

        if (parseFloat(value) > 0) {
            return arrowUp;
        }
        else if (parseFloat(value) < 0) {
            return arrowDown
        }
        else {
            return '-'
        }
    }
    const noRowsOverlayComponent = useMemo(() => {
        return OverLayLogoAMRcarregando
    }, []);

    const loadingOverlayComponent = useMemo(() => {
        return OverLayLogoAMRcarregando
    }, []);
    const onSelectionChanged = useCallback(() => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        setSelected(selectedRows.length === 1 ?selectedRows[0].contrato : '')
        setOpenChart(true)
    }, []);

    const handleClose = () => {
        gridRef.current.api.deselectAll()
        setOpenChart(false)
    }
    return (
        <div id="myGridFuturos" className="ag-theme-alpine" style={{ height: "100%", width: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', backgroundColor: 'white' }}>
                <h3 style={{ margin: 0 }}>Contratos futuros de {tabela}</h3>
            </div>
            <div style={{ height: 300 }}>
                <AgGridReact
                    ref={gridRef}//Referencia da tabela                
                    rowData={data}//Dados da tabela
                    columnDefs={columnDefs}//Carrega as configurações aplicaveis as colunas individualmente               
                    onGridReady={handleGridReady}//Adicioanando um Listener para o evento de Carregamento da tabela              
                    loadingOverlayComponent={loadingOverlayComponent}//Adicioanando um Listener para o evento de carregamento dos dados
                    noRowsOverlayComponent={noRowsOverlayComponent}//Adicioanando um Listener para o evento de não ter dados para serem mostrados      
                    suppressDragLeaveHidesColumns={true}//Impede que uma coluna seja arrastada para fora da grid e seja removida  
                    rowHeight={25}
                    frameworkComponents={{ arrowCellRenderer: ArrowCellRenderer }}
                    rowSelection={'single'}
                    onSelectionChanged={onSelectionChanged}
                />
                {selected && (
                    <Dialog open={openChart} onClose={handleClose || selected === ''} maxWidth="sm" fullWidth >
                        <DialogContent className={classes.mainWrapper}>
                            <div >
                                <div className={classes.bar}>
                                    <CloseRoundedIcon onClick={() => handleClose()} className={classes.icon} />
                                </div>

                                <div className={classes.contentWrapper}>
                                    <GraficoFuturosComponent parametros={{ "contratos": [selected], "tabela": selectedTabela }} />
                                    
                                </div>
                            </div>

                        </DialogContent>
                    </Dialog>
                )}
            </div>
        </div>
    );
}

const useStyles = makeStyles({
    mainWrapper: {
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        border: '1px solid lightgray',
        boxSizing: 'border-box'
    },

    contentWrapper: {
        overflow: 'auto',
        boxSizing: 'border-box',
        height: '100%',
        width: '100%',
        background: 'white',

    },

    bar: {
        minHeight: 22,
        display: 'flex',
        justifyContent: 'flex-end',
        borderBottom: '1px solid lightgray',

        fontFamily: 'Poppins',
        fontSize: 14,
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
    },

    icon: {
        color: '#747474',
        fontSize: 22,
        cursor: 'pointer',
        '&:hover': {
            color: '#383838'
        }
    }
})